export default __webpack_public_path__ + "static/media/create-span.cc920c49.gif";